import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent } from "vue"
import _imports_0 from '@/assets/socials/messenger.png'
import _imports_1 from '@/assets/socials/telegram.png'
import _imports_2 from '@/assets/socials/viber.png'
import _imports_3 from '@/assets/socials/whatsapp.png'
import _imports_4 from '@/assets/socials/facebook.png'
import _imports_5 from '@/assets/socials/linkedin.png'
import _imports_6 from '@/assets/socials/skype.png'
import _imports_7 from '@/assets/socials/twitter.png'
import _imports_8 from '@/assets/socials/email.png'


const _hoisted_1 = { class: "social-share__item" }
const _hoisted_2 = { class: "social-share__element" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["width", "height"]
const _hoisted_5 = {
  key: 0,
  class: "social-share__item"
}
const _hoisted_6 = { class: "social-share__item" }
const _hoisted_7 = { class: "ds-panel ds-panel--space_lg" }
const _hoisted_8 = { class: "ds-panel__element ds-panel__element--offset_full" }
const _hoisted_9 = { class: "social-share__item" }
const _hoisted_10 = { class: "social-share__element" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppIcon = _resolveComponent("AppIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["social-share", $props.classes])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.mainSocials, (social) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          ('messenger' === social && $setup.facebookAppId && $setup.shareMessengerLink)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: $setup.shareMessengerLink,
                target: "_blank",
                rel: "noopener noreferrer"
              }, [
                _createElementVNode("img", {
                  width: $props.imageSize,
                  height: $props.imageSize,
                  src: _imports_0,
                  loading: "lazy",
                  decoding: "async",
                  alt: "messenger icon"
                }, null, 8, _hoisted_4)
              ], 8, _hoisted_3))
            : (_openBlock(), _createBlock($setup["ShareNetwork"], {
                key: 1,
                url: $props.link,
                network: social,
                title: $setup.props.title,
                rel: "noopener noreferrer"
              }, {
                default: _withCtx(() => [
                  ($setup.SOCIALS_MAP.telegram === social)
                    ? (_openBlock(), _createElementBlock("img", _mergeProps({
                        key: 0,
                        class: "social-share__img",
                        ref_for: true
                      }, { ...$setup.defaultImgAttributes(social) }, { src: _imports_1 }), null, 16))
                    : ($setup.SOCIALS_MAP.messenger === social)
                      ? (_openBlock(), _createElementBlock("img", _mergeProps({
                          key: 1,
                          class: "social-share__img",
                          ref_for: true
                        }, { ...$setup.defaultImgAttributes(social) }, { src: _imports_0 }), null, 16))
                      : ($setup.SOCIALS_MAP.viber === social)
                        ? (_openBlock(), _createElementBlock("img", _mergeProps({
                            key: 2,
                            class: "social-share__img",
                            ref_for: true
                          }, { ...$setup.defaultImgAttributes(social) }, { src: _imports_2 }), null, 16))
                        : ($setup.SOCIALS_MAP.whatsapp === social)
                          ? (_openBlock(), _createElementBlock("img", _mergeProps({
                              key: 3,
                              class: "social-share__img",
                              ref_for: true
                            }, { ...$setup.defaultImgAttributes(social) }, { src: _imports_3 }), null, 16))
                          : ($setup.SOCIALS_MAP.facebook === social)
                            ? (_openBlock(), _createElementBlock("img", _mergeProps({
                                key: 4,
                                class: "social-share__img",
                                ref_for: true
                              }, { ...$setup.defaultImgAttributes(social) }, { src: _imports_4 }), null, 16))
                            : ($setup.SOCIALS_MAP.linkedin === social)
                              ? (_openBlock(), _createElementBlock("img", _mergeProps({
                                  key: 5,
                                  class: "social-share__img",
                                  ref_for: true
                                }, { ...$setup.defaultImgAttributes(social) }, { src: _imports_5 }), null, 16))
                              : ($setup.SOCIALS_MAP.skype === social)
                                ? (_openBlock(), _createElementBlock("img", _mergeProps({
                                    key: 6,
                                    class: "social-share__img",
                                    ref_for: true
                                  }, { ...$setup.defaultImgAttributes(social) }, { src: _imports_6 }), null, 16))
                                : ($setup.SOCIALS_MAP.twitter === social)
                                  ? (_openBlock(), _createElementBlock("img", _mergeProps({
                                      key: 7,
                                      class: "social-share__img",
                                      ref_for: true
                                    }, { ...$setup.defaultImgAttributes(social) }, { src: _imports_7 }), null, 16))
                                  : ($setup.SOCIALS_MAP.email === social)
                                    ? (_openBlock(), _createElementBlock("img", _mergeProps({
                                        key: 8,
                                        class: "social-share__img",
                                        ref_for: true
                                      }, { ...$setup.defaultImgAttributes(social) }, { src: _imports_8 }), null, 16))
                                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["url", "network", "title"]))
        ])
      ]))
    }), 256)),
    ($props.isShowCopy)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "social-share__element social-share__element--variant_copy",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$copyToClipboard($props.link, $setup.copiedCallback)), ["prevent"]))
          }, [
            _createVNode(_component_AppIcon, {
              name: "i-document-copy",
              size: $props.iconSizes
            }, null, 8, ["size"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(), _createBlock(_resolveDynamicComponent($setup.isMobileDeviceType ? 'div' : 'VDropdown'), { placement: 'left' }, {
        popper: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: _normalizeClass(["social-share", $props.classes])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.additionalSocials, (social) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode($setup["ShareNetwork"], {
                        url: $props.link,
                        network: social,
                        title: $setup.props.title,
                        rel: "noopener noreferrer"
                      }, {
                        default: _withCtx(() => [
                          ($setup.SOCIALS_MAP.telegram === social)
                            ? (_openBlock(), _createElementBlock("img", _mergeProps({
                                key: 0,
                                class: "social-share__img",
                                ref_for: true
                              }, { ...$setup.defaultImgAttributes(social) }, { src: _imports_1 }), null, 16))
                            : ($setup.SOCIALS_MAP.messenger === social)
                              ? (_openBlock(), _createElementBlock("img", _mergeProps({
                                  key: 1,
                                  class: "social-share__img",
                                  ref_for: true
                                }, { ...$setup.defaultImgAttributes(social) }, { src: _imports_0 }), null, 16))
                              : ($setup.SOCIALS_MAP.viber === social)
                                ? (_openBlock(), _createElementBlock("img", _mergeProps({
                                    key: 2,
                                    class: "social-share__img",
                                    ref_for: true
                                  }, { ...$setup.defaultImgAttributes(social) }, { src: _imports_2 }), null, 16))
                                : ($setup.SOCIALS_MAP.whatsapp === social)
                                  ? (_openBlock(), _createElementBlock("img", _mergeProps({
                                      key: 3,
                                      class: "social-share__img",
                                      ref_for: true
                                    }, { ...$setup.defaultImgAttributes(social) }, { src: _imports_3 }), null, 16))
                                  : ($setup.SOCIALS_MAP.facebook === social)
                                    ? (_openBlock(), _createElementBlock("img", _mergeProps({
                                        key: 4,
                                        class: "social-share__img",
                                        ref_for: true
                                      }, { ...$setup.defaultImgAttributes(social) }, { src: _imports_4 }), null, 16))
                                    : ($setup.SOCIALS_MAP.linkedin === social)
                                      ? (_openBlock(), _createElementBlock("img", _mergeProps({
                                          key: 5,
                                          class: "social-share__img",
                                          ref_for: true
                                        }, { ...$setup.defaultImgAttributes(social) }, { src: _imports_5 }), null, 16))
                                      : ($setup.SOCIALS_MAP.skype === social)
                                        ? (_openBlock(), _createElementBlock("img", _mergeProps({
                                            key: 6,
                                            class: "social-share__img",
                                            ref_for: true
                                          }, { ...$setup.defaultImgAttributes(social) }, { src: _imports_6 }), null, 16))
                                        : ($setup.SOCIALS_MAP.twitter === social)
                                          ? (_openBlock(), _createElementBlock("img", _mergeProps({
                                              key: 7,
                                              class: "social-share__img",
                                              ref_for: true
                                            }, { ...$setup.defaultImgAttributes(social) }, { src: _imports_7 }), null, 16))
                                          : ($setup.SOCIALS_MAP.email === social)
                                            ? (_openBlock(), _createElementBlock("img", _mergeProps({
                                                key: 8,
                                                class: "social-share__img",
                                                ref_for: true
                                              }, { ...$setup.defaultImgAttributes(social) }, { src: _imports_8 }), null, 16))
                                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["url", "network", "title"])
                    ])
                  ]))
                }), 256))
              ], 2)
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "social-share__element social-share__element--variant_more",
            rel: "noopener noreferrer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.isMobileDeviceType ? $setup.navigatorShare() : () => {}))
          }, [
            _createVNode(_component_AppIcon, {
              name: "i-more",
              size: $props.iconSizes
            }, null, 8, ["size"])
          ])
        ]),
        _: 1
      }))
    ])
  ], 2))
}